var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_item form_summary"},[_c('Form_Label',{attrs:{"name":_vm.name,"label":_vm.label,"info":_vm.info}}),_c('div',{staticClass:"input"},[_c('p',[_vm._v(_vm._s(_vm.value))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }